export const SEASON_IDS = ["spring", "summer", "autumn", "winter"] as const;

export type Season = (typeof SEASON_IDS)[number];

export function isSeason(value: unknown): value is Season {
  return (
    typeof value === "string" &&
    (SEASON_IDS as readonly string[]).includes(value)
  );
}
